<template>
		<div class="index">
				<div class="swiper-box">
						<a-carousel autoplay>
								<div v-for="(item,index) in slideList" v-bind:key="index">
										<a v-bind:href="'/#/product/'+item.id"><img :src="imgUrl+item.img"></a>
								</div>
						</a-carousel>
				</div>

				<div class="container tubiao flex-row flex-y-center" v-if="homeInfo.process_show==1">
						<div class="tubiao-item flex-col flex-y-center flex-x-center">
								<div class="iconfont1 iconfont icon-jisuanqi"></div>
								<p>{{ homeInfo.process_1_title }}</p>
								<span>{{ homeInfo.process_1_desc }}</span>
								<div class="iconfont2 iconfont icon-right-circle-fill"></div>
						</div>
						<div class="line flex-grow-0"></div>
						<div class="tubiao-item flex-col flex-y-center flex-x-center">
								<div class="iconfont1 iconfont icon-gongzuoguiji"></div>
								<p>{{ homeInfo.process_2_title }}</p>
								<span>{{ homeInfo.process_2_desc }}</span>
								<div class="iconfont2 iconfont icon-right-circle-fill"></div>
						</div>
						<div class="line flex-grow-0"></div>
						<div class="tubiao-item flex-col flex-y-center flex-x-center">
								<div class="iconfont1 iconfont icon-jijian"></div>
								<p>{{ homeInfo.process_3_title }}</p>
								<span>{{ homeInfo.process_3_title }}</span>
								<div class="iconfont2 iconfont icon-right-circle-fill"></div>
						</div>
						<div class="line flex-grow-0"></div>
						<div class="tubiao-item flex-col flex-y-center flex-x-center">
								<div class="iconfont1 iconfont icon-fuzhixiadan"></div>
								<p>{{ homeInfo.process_4_title }}</p>
								<span>{{ homeInfo.process_3_title }}</span>
								<div class="iconfont2 iconfont icon-right-circle-fill"></div>
						</div>
				</div>

				<div class="container about flex-row" v-if="homeInfo.home_show==1">
						<div class="flex-col flex-grow-1">
								<div class="about-title flex-row flex-y-center">
										<p>{{ homeInfo.home_name }}</p>
										<span>公司简介</span>
								</div>
								<div class="about-title-en">ABOUT US</div>
								<div class="desc">{{ homeInfo.home_introduce1 }}</div>
						</div>
						<img class="flex-grow-0" :src="imgUrl+homeInfo.home_img">
				</div>

				<div class="server">
						<div class="container flex-row flex-y-center">
								<div class="flex-row flex-y-center">
										<div class="server-item flex-col">
												<div class="server-item-title">成立时间</div>
												<div class="flex-row flex-y-bottom">
														<p>{{ homeInfo.info_time }}</p>
														<span>年</span>
												</div>
										</div>

										<div class="server-item flex-col">
												<div class="server-item-title">注册资金</div>
												<div class="flex-row flex-y-bottom">
														<p>{{ homeInfo.info_fund }}</p>
														<span>万元</span>
												</div>
										</div>

										<div class="server-item flex-col">
												<div class="server-item-title">{{ homeInfo.info_airline_nation }}</div>
												<div class="flex-row flex-y-bottom">
														<p>{{ homeInfo.info_airline_num }}+</p>
														<span>航线</span>
												</div>
										</div>
								</div>
								<div class="buju flex-col">
										<p>{{ homeInfo.info_dist }}</p>
										<ul>
												<li class="flex-row flex-y-center"><span></span>{{ homeInfo.info_dist1 }}</li>
												<li class="flex-row flex-y-center"><span></span>{{ homeInfo.info_dist2 }}</li>
												<li class="flex-row flex-y-center"><span></span>{{ homeInfo.info_dist3 }}</li>
												<li class="flex-row flex-y-center"><span></span>{{ homeInfo.info_dist4 }}</li>
										</ul>
										<span>MORE>></span>
								</div>
						</div>

				</div>


				<div class="yewu"  v-if="homeInfo.service_show==1">
						<div class="container flex-col flex-y-center">
								<div class="about-title flex-row flex-y-center">
										<p>{{homeInfo.home_name }}</p>
										<span>主营业务</span>
								</div>
								<div class="about-title-en">MAIN BUSINESS</div>
								<div class="business flex-row">
										<ul class="flex-row flex-grow-0">
												<li class="flex-col flex-y-center flex-x-center">
														<div class="iconfont icon-diaoyun_lift_jizhuangxiang_container"></div>
														<p>{{ homeInfo.service_1_title }}</p>
														<span>{{ homeInfo.service_1_desc }}</span>
														<div class="more">MORE >></div>
												</li>
												<li class="flex-col flex-y-center flex-x-center">
														<div class="iconfont icon-kongyun"></div>
														<p>{{ homeInfo.service_2_title }}</p>
														<span>{{ homeInfo.service_2_desc }}</span>
														<div class="more">MORE >></div>
												</li>
												<li class="flex-col flex-y-center flex-x-center">
														<div class="iconfont icon-truck1"></div>
														<p>{{ homeInfo.service_3_title }}</p>
														<span>{{ homeInfo.service_3_desc }}</span>
														<div class="more">MORE >></div>
												</li>
												<li class="flex-col flex-y-center flex-x-center">
														<div class="iconfont icon-guojiwuliu"></div>
														<p>{{ homeInfo.service_4_title }}</p>
														<span>{{ homeInfo.service_4_desc }}</span>
														<div class="more">MORE >></div>
												</li>
										</ul>
										<div class="denglu flex-col flex-y-center flex-grow-0">
												<img :src="imgUrl+homeInfo.service_img">
												<p>线上操作 平台登录</p>
												<span>立即登录</span>
										</div>

								</div>
						</div>

				</div>

				<div class="news" v-if="homeInfo.news_show==1">
						<div class="container flex-col flex-y-center">
								<div class="about-title flex-row flex-y-center">
										<p>{{homeInfo.home_name}}</p>
										<span>最新资讯</span>
								</div>
								<div class="about-title-en">LATEST NEWS</div>
								<div class="news-box flex-row">
										<a :href="firstNews.url" class="flex-col first">
												<img :src="imgUrl+firstNews.thumbnail">
												<div class="flex-row">
														<div class="title flex-col flex-grow-1">
																<p>{{ firstNews.title }}</p>
																<span>{{ firstNews.description }}</span>
														</div>
														<div class="time flex-col flex-y-center flex-x-center flex-grow-0">
																<p>{{ firstNews.d }}</p>
																<span>{{ firstNews.y }}.{{ firstNews.m }}</span>
														</div>
												</div>
										</a>
										<ul class="flex-col">
												<li class="flex-row flex-grow-1 flex-y-center" v-for="(item,index) in news" :key="index">
														<a class="flex-row flex-grow-1 flex-y-center" :href="item.url">
																<div class="time flex-col flex-y-center flex-x-center flex-grow-0">
																		<p>{{ item.d }}</p>
																		<span>{{ item.y }}.{{ item.m }}</span>
																</div>
																<div class="title flex-col flex-grow-1">
																		<p>{{ item.title }}</p>
																		<span>{{ item.description }}</span>
																</div>
														</a>
												</li>
										</ul>
								</div>
								<div class="more"><a :href="'/list/'+homeInfo.news_show_columnid">查看更多</a></div>
						</div>
				</div>

				<!--<modal
						title="提示"
						sureText="查看购物车"
						btnType="1"
						modalType="middle"
						v-bind:showModal="showModal"
						v-on:submit="goToCart"
						v-on:cancel="showModal=false"
				>
						<template v-slot:body>
								<p>商品添加成功！</p>
						</template>
				</modal>-->
		</div>
</template>
<script>
import {getCurrentInstance, onMounted, reactive, ref,computed} from 'vue'
import {ElLoading} from "element-plus";
import Cookies from "js-cookie";

export default {
		name: 'index',
		components: {},
		setup() {
				const {proxy} = getCurrentInstance();
				const siteUrl= proxy.$siteUrl;
				const imgUrl= proxy.$imgUrl;
				const slideList=ref([]);
				const homeInfo=ref([]);
				const firstNews=ref('');
				const news=ref([]);
				const loading=ref(null);
				let setting = computed(() => {
						return proxy.$store.state.setting;
				});


				const getslideList = () => {
						proxy.$axios.get("/home/getBannerList", {
								params: {},
						}).then((res) => {
								//console.log("BannerList",res);
								slideList.value = reactive(res.data);
						});
				};
				const getHome = () => {
						loading.value = ElLoading.service({
								lock: true,
								text: '加载中',
								background: 'rgba(0, 0, 0, 0.7)',
						})
						proxy.$axios.get("/home/getHome", {
								params: {},
						}).then((res) => {
								homeInfo.value = reactive(res.data);
								document.title = '首页-'+setting.value.webname;
								getArticleList(res.data.news_show_columnid)
						});
				};

				const getArticleList = (id) => {
						proxy.$axios.get("/home/getArticleList", {
								params: {column_id:id},
						}).then((res) => {
								console.log("getArticleList",res);
								let list=reactive(res.data);
								for(let i in list){
										let ymd=list[i].release_time.split(' ')[0];
										list[i].d=ymd.split('-')[2]
										list[i].y=ymd.split('-')[0]
										list[i].m=ymd.split('-')[1]
								}
								firstNews.value=list[0]
								news.value = list;
								loading.value.close()
						});
				};


				const phoneList = ref([])
				const showModal = ref(false)

				onMounted(() => {
						/*document.title = '蜂航国际物流';*/
						proxy.$store.dispatch("catId", 0);
						proxy.$store.dispatch("catParentId", 0);
						getslideList();
						getHome();
						//getArticleList();
				})

				const addCart = async (id) => {
						const res = proxy.$axios.post('/carts', {
								productId: id,
								selected: true
						})
						showModal.value = true;
						proxy.$store.dispatch('saveCartCount', res.cartTotalQuantity);
				}
				const goToCart = () => {
						proxy.$router.push('/cart');
				}
				return {
						siteUrl,
						imgUrl,
						slideList,
						homeInfo,
						news,
						firstNews,
						phoneList,
						showModal,
						addCart,
						goToCart
				}
		}
}
</script>
<style lang="scss" scoped>
@import './../assets/scss/config.scss';
@import './../assets/scss/mixin.scss';

.index {
		.swiper-box {
				.swiper-container {
						height: 451px;

						.swiper-button-prev {
								left: 274px;
						}

						img {
								width: 100%;
								height: 100%;
						}
				}
				.ant-carousel .slick-dots-bottom {
						bottom: 70px;
				}
				.slick-list{
						img{
								max-height: 711px;
						}
				}
		}

		.tubiao{
				background: #ffffff;
				border-radius: 20px;
				margin-top: -50px;
				justify-content: space-evenly;
				.tubiao-item{
						width: 25%;
						height: 187px;
						&:hover{
								background: #fb512d;
								cursor: pointer;
								height: 210px;
								margin-top: -23px;
								border-radius: 8px;
								.iconfont1{
										color: #ffffff;
								}
								.iconfont2{
										color: #ffffff;
										display: block;
										font-size: 30px;
								}
								p{
										color: #ffffff;
								}
								span{
										color: #ffffff;
								}
						}
				}
				.line{
						width: 2px;
						height: 60px;
						background:  #E5E5E5;
				}
				.iconfont1{
						color: #8b8b8b;
						font-size: 60px;
						margin-top: -10px;
				}
				.iconfont2{
						display: none;
				}
				p{
						color: #000000;
						font-size: 18px;
						font-weight: bold;
						margin-top: -5px;
						margin-bottom: 5px;
				}
				span{
						color: #333333;
						font-size: 16px;
				}
		}


		.about-title{
				p{
						font-size: 30px;
						font-weight: bold;
						color:#000000;
						margin-bottom: 0;
				}
				span{
						color:#fb512d;
						margin-left: 5px;
						font-size: 30px;
						font-weight: bold;
				}
		}
		.about-title-en{
				font-size: 20px;
				font-family: fangsong;
				font-weight: bold;
				letter-spacing: 1px;
		}
		.about{
				margin-top: 50px;
				.desc{
						margin-top: 30px;
						font-size: 18px;
						color: #666666;
						line-height: 40px;
				}
		}

		.server{
				margin: 50px 0;
				background: url("./../assets/imgs/server.jpg") no-repeat center;
				height: 158px;
				.container{
						height: 158px;
						position: relative;
						.server-item{
								margin-right: 200px;
								font-weight: bold;
								.server-item-title{
										font-size: 17px;
								}
								.flex-y-bottom{
										p{
												font-size: 30px;
										}
										span{
												font-size: 20px;
												margin-bottom: 5px;
												margin-left: 3px;
										}
								}
						}

						.buju{
								position: absolute;
								bottom:0;
								right: 0;
								height: 245px;
								width: 407px;
								background: #fb512d;
								color: #ffffff;
								padding:25px 30px;
								p{
										font-size: 22px;
										margin-bottom: 20px;
								}
								li{
										font-size: 17px;
										line-height: 30px;
										span{
												width: 5px;
												height: 5px;
												border-radius: 5px;
												background: #ffffff;
												display: inline-block;
												margin-right: 5px;
										}
								}
								&>span{
										font-size: 15px;
										margin-top: 10px;
								}
						}
				}
		}

		.yewu{
				margin-top: 90px;
				.business{
						margin-top: 20px;
						width: 100%;
						justify-content: space-between;
						ul{
								flex-wrap: wrap;
								width: 754px;
								border-right: 2px solid  #E5E5E5;
								border-bottom: 2px solid  #E5E5E5;
								li{
										width: 376px;
										height: 286px;
										/*border: 2px solid #9d9d9d;*/
										color: #8b8b8b;
										border-left: 2px solid  #E5E5E5;
										border-top: 2px solid  #E5E5E5;
										.iconfont{
												font-size: 70px;
										}
										p{
												font-size: 22px;
												font-weight: bold;
										}
										span{
												font-size: 16px;
												font-weight: bold;
										}
										.more{
												margin-top: 10px;
												a{
														color: #333333;
												}
										}
										&:hover{
												background: #fb512d;
												color: #ffffff;
										}
								}
						}
						.denglu{
								width: 460px;
								height: 572px;
								position: relative;
								/*background: url("./../assets/imgs/index_denglu.jpg") no-repeat center;*/
								img{
										position: absolute;
										top:0;
										left:0;
										width: 460px;
										height: 572px;
										z-index: -1;
								}
								p{
										text-align: center;
										color: #ffffff;
										font-size: 28px;
										font-weight: bold;
										margin-top: 380px;
										margin-bottom: 30px;
								}
								span{
										display: inline-block;
										width: 80%;
										height: 56px;
										line-height: 56px;
										text-align: center;
										background: #ffce0e;
										font-size: 25px;
										font-weight: bold;
										color: #000000;
										&:hover{
												cursor: pointer;
										}
								}
						}
				}

		}

		.news{
				margin-top: 90px;
				margin-bottom: 50px;
				.news-box {
						margin-top: 20px;
						width: 100%;
						justify-content: space-between;
						.first{
								height: 520px;
								width: 620px;
								border: 2px solid #E5E5E5;
								padding:42px;
								img{
										width: 100%;
										margin-bottom: 36px;
								}
						}
						ul{
								height: 520px;
								width: 587px;
								border-top: 2px solid #E5E5E5;
								border-bottom: 2px solid #E5E5E5;
								li{
										height: 173px;
										width: 100%;
										padding:0 20px;
										border-left: 2px solid #E5E5E5;
										border-right: 2px solid #E5E5E5;
										.time{
												background: none;
												margin-left: 0;
												margin-right: 20px;
												color: #030303;
										}
										&:hover{
												cursor: pointer;
												background:url("./../assets/imgs/news_li_bg.jpg") no-repeat center;
										}
								}
						}

						.title{
								p{
										font-size: 22px;
										color: #474747;
										font-weight: bold;
										margin-bottom: 10px;
										overflow: hidden;
										text-overflow: ellipsis;
										white-space: nowrap;
								}
								span{
										font-size: 18px;
										color: #4f4f4f;
										display: inline-block;
										text-align: justify;
										max-height: 56px;
										overflow: hidden;
								}
						}
						.time{
								margin-left: 20px;
								width: 94px;
								height: 88px;
								background: #fb512d;
								color: #ffffff;
								p{
										font-size: 40px;
										font-weight: bold;
										line-height: 35px;
										margin-bottom: 10px;
								}
								span{
										font-size: 18px;
										margin-top: -10px;
								}
						}
				}
				.more{
						color:#fb512d;
						border:2px solid #fb512d;
						padding:5px 25px;
						border-radius: 5px;
						font-size: 18px;
						margin-top: 20px;
						a{
								color: #fb512d;
						}
						&:hover{
								cursor: pointer;
								background: #fb512d;
								a{
										color: #ffffff;
								}

						}
				}
		}
}
</style>
